// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getDatabase, ref, remove, set } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA8XdVYjJGP5SLTj2_KTrFg1fBSqglcClA",
  authDomain: "tvmaze-app-d1126.firebaseapp.com",
  databaseURL: "https://tvmaze-app-d1126-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "tvmaze-app-d1126",
  storageBucket: "tvmaze-app-d1126.appspot.com",
  messagingSenderId: "765179871360",
  appId: "1:765179871360:web:ef8a028ededb47911fa665",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

export function writeFavouriteShow(id: number, title: string, genres: string | undefined, image: string) {
  const db = getDatabase();
  set(ref(db, 'users/' + auth.currentUser?.uid + '/favourites/' + id), {
    id: id,
    title: title,
    genres: genres,
    image: image,
  });
}

export function deleteFavouriteShow(id: number) {
  const db = getDatabase();
  remove(ref(db, 'users/' + auth.currentUser?.uid + '/favourites/' + id));  
}

export function writeWatchingShow(id: number, title: string, genres: string | undefined, image: string) {
  const db = getDatabase();
  set(ref(db, 'watching/' + auth.currentUser?.uid), {
    id: id,
    title: title,
    genres: genres,
    image: image,
  });
}

export function deleteWatchingShow() {
  const db = getDatabase();
  remove(ref(db, 'watching/' + auth.currentUser?.uid));  
}